export const possiblyMarkdownRegex = /(?:[-@*_~`#>\]|])|(?:\d\.)/;
